import { NgModule } from '@angular/core';
import {
  CUSTOMER_OPEN_ORDER_LINES_PLUGIN,
  CUSTOMER_PROJECT_SELECT_PLUGIN,
  CUSTOMER_PROJECT_CREATION_PLUGIN,
  CUSTOMER_PROJECT_LIST_PLUGIN,
  RESERVATION_HISTORY_PLUGIN,
  STOCK_HISTORY_PLUGIN,
  SUPPLIER_OPEN_ORDER_LINES_PLUGIN,
  THIRD_PARTY_DOCUMENTS_PLUGIN,
} from '@digiwall/goliath-contacts/config';
import {
  CORE_DOCUMENTS_PLUGIN,
  SUBSCRIPTION_CONFIGURATION_PLUGIN,
} from '@digiwall/goliath-core/config';
import {
  ARTICLE_DOCUMENTS_PLUGIN,
  FINISHED_PRODUCT_DOCUMENTS_ANNEXES_PLUGIN,
  FINISHED_PRODUCT_DOCUMENTS_PLUGIN,
  RESTOCK_PLUGIN,
} from '@digiwall/goliath-products/config';
import { ComponentPlugin } from '@digiwall/ui-kit';

const documents: ComponentPlugin = {
  title: 'Doc::Documents',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import('./third-party-document-list/third-party-document-list.component').then(
      m => m.ThirdPartyDocumentListComponent,
    ),
};

const printTemplateSelect: ComponentPlugin = {
  loadComponent: () =>
    import('./portal-config-print-templates/portal-config-print-template.component').then(
      m => m.PrintTemplateSelectComponent,
    ),
};

const subscriptionConfiguration: ComponentPlugin = {
  loadComponent: () =>
    import(
      '../documents/customer-subscriptions/subscription-configurations/subscription-configuration.component'
    ).then(m => m.CompanySubscriptionConfigurationComponent),
};

const customerProjectDocuments: ComponentPlugin = {
  title: 'Doc::Documents',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import('./customer-project-document-list/customer-project-document-list.component').then(
      m => m.CustomerProjectDocumentListComponent,
    ),
};

const customerProjectCreationPlugin: ComponentPlugin = {
  title: 'Doc::CreateCustomerProject',
  icon: 'digi-out-green-factory',
  loadComponent: () =>
    import(
      '../documents/customer-projects/customer-project-dialog-box/customer-project-dialog-box.component'
    ).then(m => m.CustomerProjectDialogBoxComponent),
};

const customerProjectListPlugin: ComponentPlugin = {
  title: 'Contact::FinishedProducts',
  icon: 'digi-out-green-factory',
  loadComponent: () =>
    import(
      '../documents/customer-projects/customer-project-list/customer-project-list.component'
    ).then(m => m.CustomerProjectListComponent),
};

const customerProjectDocumentAnnexes: ComponentPlugin = {
  title: 'Doc::DocAnnexes',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import(
      './customer-project-document-annexes-list/customer-project-document-annexes-list.component'
    ).then(m => m.CustomerProjectDocumentAnnexesListComponent),
};

const customerOpenOrderLines: ComponentPlugin = {
  title: 'Doc::Menu:CustomerOpenOrderLines',
  icon: 'digi-out-synch',
  loadComponent: () =>
    import('./customer-open-order-lines-list/customer-open-order-lines-list.component').then(
      m => m.CustomerOpenOrderLinesListPluginComponent,
    ),
};

const supplierOpenOrderLines: ComponentPlugin = {
  title: 'Doc::Menu:CustomerOpenOrderLines',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import('./supplier-open-order-lines-list/supplier-open-order-lines-list.component').then(
      m => m.SupplierOpenOrderLinesListPluginComponent,
    ),
};

const stockHistory: ComponentPlugin = {
  title: 'Contact::History',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import('./stock-history-list/stock-history-list.component').then(
      m => m.StockHistoryListPluginComponent,
    ),
};

const reservationHistory: ComponentPlugin = {
  title: 'Contact::Reservation',
  icon: 'digi-out-info',
  loadComponent: () =>
    import('./reservation-history-list/reservation-history-list.component').then(
      m => m.ReservationHistoryListPluginComponent,
    ),
};

const restock: ComponentPlugin = {
  title: 'Doc::Restock',
  icon: 'digi-out-shop',
  loadComponent: () =>
    import('../restock/restock-creation-dialog.component').then(
      m => m.RestockCreationDialogComponent,
    ),
};

const customerProjectSelect: ComponentPlugin = {
  loadComponent: () =>
    import('./customer-project-select/customer-project-select-plugin.component').then(
      m => m.CustomerProjectSelectComponent,
    ),
};

const articleDocuments: ComponentPlugin = {
  title: 'Doc::Documents',
  icon: 'digi-out-annex',
  loadComponent: () =>
    import('./article-document-list/article-document-list.component').then(
      m => m.ArticleDocumentListComponent,
    ),
};

@NgModule({
  providers: [
    { provide: THIRD_PARTY_DOCUMENTS_PLUGIN, useValue: documents },
    { provide: CORE_DOCUMENTS_PLUGIN, useValue: printTemplateSelect },
    { provide: SUBSCRIPTION_CONFIGURATION_PLUGIN, useValue: subscriptionConfiguration },
    { provide: CUSTOMER_PROJECT_CREATION_PLUGIN, useValue: customerProjectCreationPlugin },
    { provide: CUSTOMER_PROJECT_LIST_PLUGIN, useValue: customerProjectListPlugin },
    { provide: FINISHED_PRODUCT_DOCUMENTS_PLUGIN, useValue: customerProjectDocuments },
    {
      provide: FINISHED_PRODUCT_DOCUMENTS_ANNEXES_PLUGIN,
      useValue: customerProjectDocumentAnnexes,
    },
    { provide: CUSTOMER_OPEN_ORDER_LINES_PLUGIN, useValue: customerOpenOrderLines },
    { provide: SUPPLIER_OPEN_ORDER_LINES_PLUGIN, useValue: supplierOpenOrderLines },
    { provide: STOCK_HISTORY_PLUGIN, useValue: stockHistory },
    { provide: RESERVATION_HISTORY_PLUGIN, useValue: reservationHistory },
    { provide: RESTOCK_PLUGIN, useValue: restock },
    { provide: CUSTOMER_PROJECT_SELECT_PLUGIN, useValue: customerProjectSelect },
    { provide: ARTICLE_DOCUMENTS_PLUGIN, useValue: articleDocuments },
  ],
})
export class GoliathDocumentsPluginModule {}
